import { createContext } from "react";
import { ScoreWithVariation } from "src/services/ScoreService";
import { Score, ScoreImprovement } from "src/types";
import { VariationsParams } from "src/context/OlapScores/useVariations";
import { SsqVersionSsq } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";

export type EntityScoresInit = {
    isAvailable: true;
    entity: "company" | "product" | "ingredient" | "packaging" | "transport";
    entityScores: Score[];
    getEntityScore: (scoreId: number) => Score | undefined;
    getColor: (
        score: number | null | undefined,
        options?: { improvement?: ScoreImprovement; precision?: number },
    ) => string | undefined;
    formatScore: (score: number | null | undefined, options?: { precision?: number }) => string | null;
    scoresWithVariations: ScoreWithVariation[];
    allScoresWithVariations: ScoreWithVariation[];
    diagnosticScoresWithVariations: ScoreWithVariation[];
    lastSelectedVariation: ScoreWithVariation;
    selectedVariations: VariationsParams;
    selectVariation: (scoreId: number, variationId: number | null) => void;
    selectedScorePrecision: number;
    entitySsq: SsqVersionSsq | undefined;
    setEntitySsq: (ssq: SsqVersionSsq | undefined) => void;
};
export type EntityScoresUnavailable = Pick<EntityScoresInit, "entity" | "entitySsq" | "setEntitySsq"> & {
    isAvailable: false;
};
export const EntityScoresContext = createContext<EntityScoresInit | EntityScoresUnavailable | null>(null);
